import React from 'react'
import UploadDropzone from '../UploadDropzone'

import useFetch from '../../../hook/useFetch'
import api from '../../../../api'
import { authHeader } from '../../../../_helpers/auth-header'

function DrawerForm({ action, setAction }) {
    const {
        data: {
            id,
            title,
            file,
            academic_categories_id,
            academics_id,
            attachment_id,
        },
        behavior,
    } = action

    const initialState = {
        title: behavior === 'update' ? title : '',
        file: behavior === 'update' ? file : '',
        academic_categories_id:
            behavior === 'update' ? academic_categories_id : 0,
        academics_id: behavior === 'update' ? academics_id : 1,
        attachment_id: behavior === 'update' ? attachment_id : null,
    }

    const [form, setForm] = React.useState({ ...initialState })
    const [upload, setUpload] = React.useState(null)
    const [isError, setIsError] = React.useState(null)

    const { data: academicCategories } = useFetch('/academic-categories')

    function handleChange({ target }) {
        const { id, value } = target
        setForm({ ...form, [id]: value })

        if (target.type === 'file') {
            const reader = new FileReader()
            reader.readAsDataURL(target.files[0])
            reader.onloadend = () => {
                setUpload(reader.result)
                setForm({ ...form, image: reader.result })
            }
        }
    }

    function update(id) {
        api.put(
            `/academic-files/${id}`,
            {
                title: form.title,
                file: form.file,
                academic_categories_id: form.academic_categories_id,
                academics_id: 1,
                attachment_id: form.attachment_id,
            },
            { authHeader }
        )
            .then((response) => {
                if (response.status === 200) {
                    setAction({
                        ...action,
                        behavior: '',
                        drawer: false,
                    })
                }
            })
            .catch((error) => {
                let message =
                    typeof error.response !== 'undefined'
                        ? error.response.data.message
                        : error.message
                setIsError(message)
            })
    }

    function create() {
        api.post(
            '/academic-files',
            {
                title: form.title,
                file: form.file,
                academic_categories_id: form.academic_categories_id,
                academics_id: 1,
                attachment_id: form.attachment_id,
            },
            { authHeader }
        )
            .then((response) => {
                if (response.status === 200) {
                    setAction({
                        ...action,
                        behavior: '',
                        drawer: false,
                    })
                }
            })
            .catch((error) => {
                let message =
                    typeof error.response !== 'undefined'
                        ? error.response.data.message
                        : error.message
                setIsError(message)
            })
    }

    function handleSubmit(e) {
        e.preventDefault()

        if (behavior === 'create') {
            create()
            return
        }

        if (behavior === 'update') {
            update(id)
            return
        }
    }

    React.useEffect(() => {
        if (upload) {
            setForm({
                ...form,
                file: upload.name ?? form.file,
                attachment_id: upload.id ?? form.attachment_id,
            })
        }
    }, [upload])

    return (
        <form onSubmit={handleSubmit}>
            <span className="form-group mb-4 d-block">
                <label>Título</label>
                <input
                    className="form-control"
                    id="title"
                    type="text"
                    onChange={handleChange}
                    value={form.title}
                    required
                />
            </span>

            <UploadDropzone setUpload={setUpload} />

            <span className="form-group mb-4 d-block">
                <label>URL</label>
                <input
                    className="form-control"
                    id="file"
                    type="text"
                    onChange={handleChange}
                    value={form.file}
                    required
                    disabled
                />
            </span>

            <span className="form-group mb-4 d-block">
                <label>Categoria</label>
                <select
                    id="academic_categories_id"
                    className="form-select"
                    onChange={handleChange}
                    value={form.academic_categories_id}
                >
                    <option value="0" disabled>
                        Selecione a categoria
                    </option>
                    {academicCategories.map((item) => (
                        <option key={item.id} value={item.id}>
                            {item.title}
                        </option>
                    ))}
                </select>
            </span>

            <span className="form-group">
                <button className="btn btn-primary">
                    {behavior === 'create' ? 'Salvar' : 'Atualizar'}
                </button>
            </span>

            {isError && (
                <div className="row">
                    <div className="col">
                        <p className="mt-2 bg-danger text-white rounded p-3">
                            {isError[Object.keys(isError)]}
                        </p>
                    </div>
                </div>
            )}
        </form>
    )
}

export default DrawerForm
